
export const PostHead = ({ publisher, publicationDate, readingTime }) => {
    return (
        <div className="container d-flex gap-3 post-head align-items-end mb-3 p-0" >
            <img src="/images/logo.png" alt="carros a centro america" width={60} />
            <p className="m-0 p-0">{publisher} <br className="d-lg-none" /> <span>-</span> {publicationDate} <span>-</span> {readingTime} Min. de lectura</p>
        </div>
    )
}